<script setup lang="ts">
    import { defaultAutocompleteConverter } from "@/components/forms/inputs/Autocomplete/helpers";
    import { useStore } from "@/store";
    import { flashWarning } from "@/utils";

    const { typ } = defineProps<{ typ: string }>();

    const fetchMottagare = async ({ query }: { query?: string } = {}) => {
        const store = useStore();

        try {
            const params: { is_active: boolean; typ: string; q?: string } = { is_active: true, typ: typ };

            if (query) {
                params.q = query;
            }

            const { subsetName } = await store.dispatch("remiss/mottagare/fetchMottagare", {
                filterParams: params,
                displayMode: true,
            });

            return store.getters["remiss/mottagare/mottagareSubset"]({ subsetName, displayMode: true });
        } catch (error) {
            console.error("Kunde inte hämta mottagare:", error);
            flashWarning("Kunde inte hämta mottagare.");
        }
    };
</script>

<template>
    <KAutocomplete
        name="mottagare"
        label="Mottagare"
        :options="fetchMottagare"
        :converter="defaultAutocompleteConverter"
        v-bind="$attrs"
    />
</template>

<style lang="scss" scoped></style>
